"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvbetradarStream = void 0;
const flatbuffers = require("flatbuffers");
class AvbetradarStream {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsAvbetradarStream(bb, obj) {
        return (obj || new AvbetradarStream()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsAvbetradarStream(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new AvbetradarStream()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    productId(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    productName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    startTime(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    streamStatusId(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    streamStatusName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startAvbetradarStream(builder) {
        builder.startObject(6);
    }
    static addId(builder, idOffset) {
        builder.addFieldOffset(0, idOffset, 0);
    }
    static addProductId(builder, productIdOffset) {
        builder.addFieldOffset(1, productIdOffset, 0);
    }
    static addProductName(builder, productNameOffset) {
        builder.addFieldOffset(2, productNameOffset, 0);
    }
    static addStartTime(builder, startTimeOffset) {
        builder.addFieldOffset(3, startTimeOffset, 0);
    }
    static addStreamStatusId(builder, streamStatusIdOffset) {
        builder.addFieldOffset(4, streamStatusIdOffset, 0);
    }
    static addStreamStatusName(builder, streamStatusNameOffset) {
        builder.addFieldOffset(5, streamStatusNameOffset, 0);
    }
    static endAvbetradarStream(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createAvbetradarStream(builder, idOffset, productIdOffset, productNameOffset, startTimeOffset, streamStatusIdOffset, streamStatusNameOffset) {
        AvbetradarStream.startAvbetradarStream(builder);
        AvbetradarStream.addId(builder, idOffset);
        AvbetradarStream.addProductId(builder, productIdOffset);
        AvbetradarStream.addProductName(builder, productNameOffset);
        AvbetradarStream.addStartTime(builder, startTimeOffset);
        AvbetradarStream.addStreamStatusId(builder, streamStatusIdOffset);
        AvbetradarStream.addStreamStatusName(builder, streamStatusNameOffset);
        return AvbetradarStream.endAvbetradarStream(builder);
    }
}
exports.AvbetradarStream = AvbetradarStream;
